import {INIT_APP} from '~/common/fabric/constants';
import {SET_GUEST_OPTIONS} from './constants';
import {mapGuestOptionsFromBackend} from './fieldMapping';

const initialState = {
  hideGuestlist: false,
  allowBringPeople: true,
  limitPerGuest: 9,
  maxGuestList: null,
  showMaxGuest: true,
  allowKids: false,
  allowMaybeRSVPs: true,
  rsvpDeadline: undefined,
  rsvpDeadlineIsStrict: undefined,
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case INIT_APP: {
      const {event} = action.payload ?? {};
      const options = event?.options || {};
      const mappedOptions = mapGuestOptionsFromBackend(options);

      return {
        ...initialState,
        ...mappedOptions,
        showMaxGuest: !!mappedOptions.maxGuestList,
      };
    }

    case SET_GUEST_OPTIONS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
